import { render, staticRenderFns } from "./SidebarSettings.vue?vue&type=template&id=9f7d43b2"
import script from "./SidebarSettings.vue?vue&type=script&lang=js"
export * from "./SidebarSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports